export default "__VITE_ASSET__CBwatsMi__"